import(
  /* webpackChunkName: 'materialIcons' */ "material-design-icons-iconfont/dist/material-design-icons.css"
);

import "typeface-roboto/index.css";
import "vuetify/dist/vuetify.min.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md",
  },
  theme: {
    themes: {
      light: {
        primary: "#1a427f",
        secondary: "#009a4e",
      },
    },
  },
});
